import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { ImprimirControleComponent } from '../imprimir-controle/imprimir-controle.component';
import { ControleComponent } from '../controle/controle.component';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { ConteudoService } from 'app/service/caixa/conteudo.service';

@Component({
  selector: 'app-devolver-conteudo',
  templateUrl: './devolver-conteudo.component.html',
  styleUrls: ['./devolver-conteudo.component.scss']
})
export class DevolverConteudoComponent implements OnInit {

  result ;
  resultEmRecuperacao;
  loading = false;
  pendenteDevolucao = [];
  emDevolucao = [];
  rgInput ;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  logIsvisivel = false;
  logs = [];
  controles = [];
  adm = false;
   acervo = false;
   solicitacao = true;

   solicitacoesConteudo: any;
   showCheck = false;
   solicitacaoId;

   constructor(
     private service : SolicitacaoService,
     private _snackBar: MatSnackBar,
     private dialog: MatDialog) { }

   ngOnInit() {
    this.buscarConteudoEmConsulta();
    this.buscarDocumentosSelecionadosEmDevolucao();
   }

   buscarConteudoEmConsulta() {
    this.service.buscarConteudosDevolucaoEmpresa().subscribe(data => {
      console.log(data);
      if (data.success) {
        this.pendenteDevolucao = data.result;
      }
    }, err => {
      console.error(err);
      this.openSnackBarError('Ocorreu um erro ao tentar buscar conteúdos em devolução!');
    });
   }

   buscarDocumentosSelecionados(solicId: number) {
    this.service.buscarConteudoSolicitacao(solicId).subscribe(data => {
      if (data.success) {
        this.pendenteDevolucao = data.result;
      }
    }, err => {
      console.error(err);
    });
   }

   buscarDocumentosSelecionadosEmDevolucao() {
    this.service.buscarConteudoSolicitacaoEmDevolucao().subscribe(data => {
      if (data.success) {
        this.emDevolucao = data.result;
      }
    }, err => {
      console.error(err);
    });
   }

   selectSolicitacao(event: any) {
    this.showCheck = true;
    this.solicitacaoId = event.value;
    //this.buscarDocumentosSelecionados(event.value);
    this.buscarConteudoEmConsulta();
    this.buscarDocumentosSelecionadosEmDevolucao();
   }

   addControle() {
     const dialogRef = this.dialog.open(ControleComponent, {
       width: '70%',
       data: {tipoSolicitacao: 'recuperacaoRecipiente'}
     });
     dialogRef.afterClosed().subscribe((result) => {
       this.carregarpendenteDevolucao();
       console.log(`The dialog was closed - ${result}`);
       console.log(result);
     });
   }

   imprimirControle() {
     const dialogRef = this.dialog.open(ImprimirControleComponent, {
       width: '40%',
       data: {tipoSolicitacao: '0'}
     });
     dialogRef.afterClosed().subscribe((result) => {
       console.log(result);
     });
   }

   listarControles(idsCaixas) {
     this.service.listarControles(idsCaixas).subscribe(data => {
       this.controles = data;
     }, err => {
       console.error(err);
     });
   }

   relatorioCaixasPendentes() {
     if (this.result.result.length === 0 ) {
       this.openSnackBarError('Nenhuma caixa pendente recuperação !');
     } else {
     window.open(`relatorio-caixas-pendente-recuperacao`,
     '_blank',
     'location=yes,height=570,width=520,scrollbars=yes,status=yes'); // Open new window
     }
   }

   alterarVisualizacaoLog(){
     if(this.logIsvisivel){
       this.logIsvisivel = false;
     }else{
       this.logIsvisivel = true;
     }
   }

   carregarpendenteDevolucao(){
     this.loading = true;
     this.service.listarCaixasPendeteRecuperacao().subscribe(data=>{
       this.result = data;
       if(this.result.cod == 200){
         this.pendenteDevolucao = this.result.result;
         this.loading = false;
         let caixasIds = [];
         this.pendenteDevolucao.map(el => {
           if (el.idControle !== null) {
             caixasIds.push(el.id);
           }
         });
         this.listarControles(caixasIds);
       }
     })
   }

   carregarEmRecuperacao(){
     let user = localStorage.getItem('APS_USERNAME');
     let obj = {"rgCaixa" : "", username: user};
     this.loading = true;
     this.service.caixasEmRecuperacao(obj).subscribe(data=>{
       this.resultEmRecuperacao = data;
       if(this.resultEmRecuperacao.cod == 200){
         this.emDevolucao = this.resultEmRecuperacao.result;
         this.loading = false;
       }else {
         this.openSnackBarError(this.resultEmRecuperacao.message)
         this.loading = false;
       }
     })


   }

   rgEmRecuperacao(){
     if(this.rgInput != ""){
       this.incluirRGEmRecuperacao(this.rgInput );
       this.rgInput = "";
     }

   }

   selecionarTodos() {
    let iterador = 0;
     this.pendenteDevolucao.map(el => {
      iterador++;
       this.incluirRGEmRecuperacao(el.codConteudo.toString());
     });
   }

   incluirRGEmRecuperacao(codConteudo){
    let rgCaixa;
    this.pendenteDevolucao.forEach(item => {
      if (item.codConteudo.toString() === codConteudo.toString()) {
        rgCaixa = item.rgCaixa;
      }
    });
     let obj = {"rgCaixa" : rgCaixa, "conteudoId": codConteudo};
     this.loading = true;
     this.service.devolverConteudoUnico(obj).subscribe(data => {
       this.result = data;
       if (data.success) {
        this.openSnackBarSuccess(`Contéudo: ${codConteudo} em recuperação`);
        this.buscarConteudoEmConsulta();
        this.buscarDocumentosSelecionadosEmDevolucao();
       } else {
        this.openSnackBarError(data.message);
       }
       this.loading = false;
     }, err => {
      console.error(err);
      this.loading = false;
     });
   }

   openSnackBarSuccess(message: string) {
     this._snackBar.open(message, '', {
       horizontalPosition: this.horizontalPosition,
       verticalPosition: this.verticalPosition,
       duration: 4000,
       panelClass: ['success-snackbar']
     });
   }

   openSnackBarError(message: string) {
     this._snackBar.open(message,'', {
       horizontalPosition: this.horizontalPosition,
       verticalPosition: this.verticalPosition,
       duration: 3000,
       panelClass: ['error-snackbar']
     });
   }

   recuperarRecipientesUser(){
     let user = localStorage.getItem('APS_USERNAME');
     let obj = {"rgCaixa" : "", username: user};
     this.loading = true;
     this.service.recuperarRecipientesUser(obj).subscribe(data=>{
       this.result = data;
       if(this.result.cod == 200){
         for(let i = 0 ; i < this.result.result.length; i++){
           this.logs.push("Caixa RG "+ this.result.result[i].rgCaixa + " recuperada !" + ' Controle: ' + this.result.result[i].idControle);
         }
         this.carregarEmRecuperacao();
         this.carregarpendenteDevolucao();
         this.openSnackBarSuccess("Caixas recuperadas com sucesso!");
       }else {
         this.openSnackBarError(this.result.message)
         this.loading = false;
       }
     })
   }

   devolverConteudos() {
    this.service.devolverConteudos().subscribe(data => {
      console.log(data);
      if (data.success) {
        this.emDevolucao = [];
        this.pendenteDevolucao = [];
        this.openSnackBarSuccess(data.message);
      } else {
        this.openSnackBarError(data.message);
      }
    }, err => {
      console.error(err);
    });
   }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/devolver-conteudo/devolver-conteudo.component.ts